import { Box, Flex, GridItem, Heading, HStack, Image, SimpleGrid, Text, Timeline } from '@chakra-ui/react'
import React from 'react'
import { useColorModeValue } from '../../../components/ui/color-mode'
import { LuCheck, LuCoins} from 'react-icons/lu'
import { useTranslation } from 'react-i18next'

const OurOperatingSystem = () => {

  const cardColor = useColorModeValue('white', 'gray.900')
  const textGhost = useColorModeValue('gray.800', 'gray.500')
  const timelineBgColorIcon = useColorModeValue('gray.100', 'gray.700')
  const colorIcon = useColorModeValue('gray.800', 'gray.100')
  const {t} = useTranslation()
  return (
    <Flex
      px={{ md: '10%', '2xl': "19%", base: 4 }}
      pt={20}
      pb={{'2xl': 44, md: 24, base: 0}}
      overflow={'hidden'}
      position={'relative'}
    >
      <SimpleGrid pt={{md: 10, '2xl': 'inherit', base: 12}} w={'full'} gap={{ '2xl' : 20, md: 10, base: 44}} justify={'center'} columns={{ md : 2, base: 1}} >

        <GridItem placeItems={{'2xl' : 'center', md: 'end', base: 'center'}} position={'relative'} gap={10} justify={'center'}>
          <Box position={'relative'} w={'min-content'}> 
            <Box
              bgColor={'red.500'}
              bgImage={`url(${require('../../../assets/team/4.jpeg')})`}
              bgPos={'center'}
              bgRepeat={'no-repeat'}
              bgSize={'700px 460px'}
              boxSize={{'2xl' : '300px',md: '250px', base: '200px'}}
              rounded={'full'}
            />

            <Box position={'absolute'} right={{ '2xl': '-50%', md: '-50%', base: '-44%'}} top={{'2xl' :8, base: -20}} boxShadow={'lg'} p={3} px={4} bgColor={cardColor} rounded={18}>
              <Text fontFamily={'Onest'} fontSize={'sm'}  letterSpacing={-0.4}>{t('assetText1')}</Text>
              <HStack mt={2} gap={4}>
                <Image
                  w={'40px'}
                  src={require('../../../assets/manage.png')}
                />
                <Heading fontSize={'3xl'} fontFamily={'Outfit'}>
                  95%
                </Heading>
              </HStack>
            </Box>


            <Box position={'absolute'} w={{'2xl' : '300px', md: '250px', base: '200px'}} right={{'2xl': '-70%', md: '-70%', base: '44%'}} bottom={{ '2xl' :'-50%', base: '-70%'}} boxShadow={'lg'}  px={4} pt={1} pb={6} bgColor={cardColor} rounded={18}>
              <Heading ml={2} py={2} borderBottom={'1px solid'} borderColor={useColorModeValue('gray.100', 'gray.600')} fontFamily={'Onest'} fontSize={{ '2xl' :'lg', base: 'md'}} lineHeight={{'2xl': 'inherit', base: 1.2}}>
                {t('assetText2')}
              </Heading>

              <Timeline.Root colorPalette={'blue'} size={{ '2xl':'lg', base: 'sm'}} px={2} mt={4} maxW="300px">
                <Timeline.Item>
                  <Timeline.Connector>
                    <Timeline.Separator />
                    <Timeline.Indicator>
                      <LuCoins />
                    </Timeline.Indicator>
                  </Timeline.Connector>
                    <Timeline.Content>
                      <Timeline.Title fontFamily={'Onest'}>{t('assetText3')}</Timeline.Title>
                    <Timeline.Description>{t('assetDescription3')}</Timeline.Description>
                  </Timeline.Content>
                </Timeline.Item>

                <Timeline.Item>
                  <Timeline.Connector>
                    <Timeline.Separator />
                    <Timeline.Indicator bgColor={timelineBgColorIcon} color={colorIcon}>
                      <LuCheck />
                    </Timeline.Indicator>
                  </Timeline.Connector>
                  <Timeline.Content>
                    <Timeline.Title fontFamily={'Onest'}>{t('assetText4')}</Timeline.Title>
                    <Timeline.Description>{t('assetDescription4')}</Timeline.Description>
                  </Timeline.Content>
                </Timeline.Item>

                <Timeline.Item display={{'2xl': 'inherit', base: 'none'}}>
                  <Timeline.Connector>
                    <Timeline.Separator />
                    <Timeline.Indicator bgColor={timelineBgColorIcon} color={colorIcon}>
                      <LuCheck />
                    </Timeline.Indicator>
                  </Timeline.Connector>
                  <Timeline.Content>
                    <Timeline.Title fontFamily={'Onest'}>{t('assetText5')}</Timeline.Title>
                    <Timeline.Description>{t('assetDescription5')}</Timeline.Description>
                  </Timeline.Content>
                </Timeline.Item>
              </Timeline.Root>

            </Box>
          </Box>
        </GridItem>
            


        <GridItem placeItems={'start'}>
          <Heading fontFamily={'Onest'} fontSize={{'2xl': '2xl', base: 'lg'}}>
            {t('advantagesTitle1')}
          </Heading>

          <Text mt={{'2xl' :2, base: 0}} color={textGhost} maxW={'400px'}>{t('advantagesSubtitle1')}</Text>

          <Heading mt={4} fontFamily={'Onest'} fontSize={{'2xl': '2xl', base: 'lg'}}>{t('advantagesTitle2')}</Heading>
          <Text mt={{'2xl' :2, base: 0}} color={textGhost} maxW={'400px'}>{t('advantagesSubtitle2')}</Text>

          <Heading mt={4} fontFamily={'Onest'} fontSize={{'2xl': '2xl', base: 'lg'}}>{t('advantagesTitle3')}</Heading>
          <Text mt={{'2xl' :2, base: 0}} color={textGhost} maxW={'400px'}>{t('advantagesSubtitle3')}</Text>

          <Heading mt={4} fontFamily={'Onest'} fontSize={{'2xl': '2xl', base: 'lg'}}>{t('advantagesTitle4')}</Heading>
          <Text mt={{'2xl' :2, base: 0}} color={textGhost} maxW={'400px'}>{t('advantagesSubtitle4')}</Text>
        </GridItem>
      </SimpleGrid>
      
    </Flex>
  )
}

export default OurOperatingSystem